// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/gifs/ajax_loader.gif");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".v2-ajax-loader{position:absolute;width:100%;height:100%;z-index:400;top:0;display:flex;justify-content:center;align-items:center;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat center center rgba(255,255,255,0.7)}\n", ""]);
// Exports
module.exports = exports;
